import $ from "cash-dom";
import { grabOnInit } from "@core";
import contactFormInit from "@common/forms/contact-form";

/**
 * /contact-us/.
 *
 * The whole page is the form plus an address, so the bundle is the form module
 * and the shared chrome — grabOnInit brings the header, the search box, the
 * country switcher and the `.go-redirection` delegate the map and phone links
 * ride on.
 */
$(function onReady() {
  grabOnInit();
  contactFormInit();
});
